import { StartNoisemeter as DLStartNoisemeter, StopNoisemeter as DLStopNoisemeter, ResetNoisemeter as DLResetNoisemeter, GetNoisemeterStats as DLGetNoisemeterStats, GetActiveZones as DLGetActiveZones, ReportNoiseLevel as DLReportNoiseLevel, GetNoisemeterState as DLGetNoisemeterState } from './../../../DL/Admin/Overlays/Noisemeter'


//===== ADMIN =====//

const StartNoisemeter = async (gameData) => {
    try {
        // gameData debe traer: { durationSeconds, sensitivity, targetZone, countdownSeconds }
        const response = await DLStartNoisemeter(gameData)
    
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Start).' }
    }
}

const StopNoisemeter = async () => {
    try {
        const response = await DLStopNoisemeter()
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Stop).' }
    }
}

const ResetNoisemeter = async () => {
    try {
        const response = await DLResetNoisemeter()
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Reset).' }
    }
}

const GetNoisemeterStats = async () => {
    try {
        const response = await DLGetNoisemeterStats()
        // Aquí podrías formatear datos si fuera necesario antes de enviarlos a la vista
        return response
    } catch (error) {
        return { success: false, message: 'Error inesperado en BL (Stats).' }
    }
}

const GetZonesList = async () => {
    try {
        const response = await DLGetActiveZones()
        
        if (response.success && response.data) {
            // // La API (GetWomensBalance o similar) suele devolver un objeto: { "azul": 5, "oro": 10 }
            // // Nosotros solo queremos los NOMBRES de las zonas para el <select>
            // const zonesArray = Object.keys(response.data);
            
            // return { success: true, data: zonesArray }

            
            // CORRECCIÓN:
            // El endpoint ahora devuelve un Array directo ["azul", "oro"].
            // Si hacemos Object.keys(["azul", "oro"]) obtendremos los índices ["0", "1"].
            
            // Validamos si ya es un array para devolverlo directo:
            if (Array.isArray(response.data)) {
                return { success: true, data: response.data }
            }

            // Fallback: Si llegara como objeto { azul: 0, oro: 0 }, entonces sí sacamos las keys.
            const zonesArray = Object.keys(response.data);
            return { success: true, data: zonesArray }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Error obteniendo lista de zonas.' }
    }
}

//===== ADMIN =====//



//===== FAN =====//

const SendNoiseReport = async (matchId, zone, volume) => {
    // Validaciones rápidas para no saturar la red con datos basura
    if (!matchId || !zone || volume < 0) return;

    const payload = {
        matchId: matchId,
        zone: zone, // "azul", "oro", etc.
        volume: parseFloat(volume)
    };

    // No necesitamos esperar la respuesta (await) estrictamente si queremos velocidad,
    // pero para mantener el orden lo dejamos así.
    await DLReportNoiseLevel(payload);
}

//===== FAN =====//





//===== SCREEN =====//

const GetScreenState = async () => {
    try {
        const response = await DLGetNoisemeterState()
        
        if (response.success) {
            // Aquí podríamos formatear datos si fuera necesario, 
            // pero el DTO del backend ya viene muy limpio.
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        return { success: false, message: 'Error inesperado.' }
    }
}

//===== SCREEN =====//

export { StartNoisemeter, StopNoisemeter, ResetNoisemeter, GetNoisemeterStats, GetZonesList, SendNoiseReport, GetScreenState };